export const createModal = (content, modalId) => {
    const modal = document.createElement('div');
    modal.id = modalId;
    modal.className = 'custom_modal';
    modal.innerHTML = `
        <div class="modal__overlay"></div>
        <div class="modal__container" role="dialog" aria-modal="true">
            <button class="modal__close" aria-label="Close">
                <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="times-circle" class="svg-inline--fa fa-times-circle fa-w-16 fa-3x icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 49">
                    <path fill="currentColor" d="M24 5.75a18.76 18.76 0 000 37.5 18.76 18.76 0 000-37.5zm0 1.5c9.54 0 17.25 7.71 17.25 17.25S33.54 41.75 24 41.75A17.24 17.24 0 016.75 24.5c0-9.54 7.71-17.25 17.25-17.25zm-5.65 10.84a.75.75 0 00-.54.22.75.75 0 000 1.06l5.13 5.13-5.13 5.13a.75.75 0 000 1.06.75.75 0 001.06 0L24 25.56l5.13 5.13a.75.75 0 001.06 0 .75.75 0 000-1.06l-5.13-5.13 5.13-5.13a.75.75 0 000-1.06.75.75 0 00-1.06 0L24 23.44l-5.13-5.13a.75.75 0 00-.52-.22z">
                    </path>
                </svg>
            </button>
            <div class="modal__inner">
                <div class="modal__content"></div>
            </div>
        </div>
    `;

    modal.querySelector('.modal__content').appendChild(content.cloneNode(true));
    return modal;
};

export const openModal = (modalId) => {
    const modal = document.getElementById(modalId);
    if (modal) {
        modal.classList.add('is-active');
        document.body.classList.add('modal-open');
    }
};

export const closeModal = (modalId) => {
    const modal = document.getElementById(modalId);
    if (modal) {
        modal.classList.remove('is-active');
        document.body.classList.remove('modal-open');
    }
};

export const generateUniqueId = (() => {
    let counter = 0;
    return () => `modal-${Date.now()}-${counter++}`;
})();

export const addCloseEventListener = () => {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
          const activeModal = document.querySelector('.modal.is-active');
          if (activeModal) {
              closeModal(activeModal.id);
          }
      }
    });
} 
